import React from 'react';

const styles = {width: '99vw', height: '88vh'};

function Cosecha() {
    return (
        <iframe
        title='Cosecha'
        src="https://geologiaconce.maps.arcgis.com/apps/dashboards/7d2b62dd36db4c5c9fa1457f7300e310" 
        style={styles}>
        </iframe>
    )
}

export default Cosecha